import { defineMessages } from 'react-intl';

const messages = defineMessages({
  exchange: {
    description: 'Label for pill indicating the current shipment is an exchange',
    defaultMessage: 'Exchange',
    id: 'DWKY32',
  },
});

export default messages;
